import { ISearchHistoryParams } from './dto/ISearchHistoryParams';
import { requests } from '../../../../../utils';
import { BRAND_BOOKING_EXTERNAL_SEARCH } from '../../../../../utils/endpoints';
import { ISearchRequest } from './dto/ISearchRequest';
import { IExternalSearchBaseModel } from './dto/IExternalSearchBaseModel';
import { IExternalSearchProfile } from './dto/IExternalSearchProfile';
import { IDetailModalData } from './dto/IDetailModalData';

export const ExternalSearchService = {
    getHistoryProfiles: (params: ISearchHistoryParams): Promise<IExternalSearchBaseModel> =>
        requests.get(`${BRAND_BOOKING_EXTERNAL_SEARCH}/history`, params),
    getHistoryProfileDetail: (
        id: number,
        isInternal?: boolean,
        fromExternalSearch?: boolean
    ): Promise<IDetailModalData> =>
        requests.get(`${BRAND_BOOKING_EXTERNAL_SEARCH}/modal/${id}`, { isInternal, fromExternalSearch }),
    getExternalProfile: (body: ISearchRequest, campaignId?: string): Promise<IExternalSearchProfile> =>
        requests.put(`${BRAND_BOOKING_EXTERNAL_SEARCH}/profile/${campaignId}`, body),
    sendRequest: (id: number, campaignId: string | null): Promise<IExternalSearchProfile> =>
        requests.put(`${BRAND_BOOKING_EXTERNAL_SEARCH}/request/${id}/${campaignId}`, {}),
};
